<template>
    <div>
        <div v-if="isJJ">
            <JJMainLayout />
        </div>
        <div v-else>
            <MainLayout />
        </div>
    </div>
</template>

<script>

import MainLayout from './components/MainLayout.vue';
import JJMainLayout from './components/views/TPG/jimmyjohns/JJMainLayout.vue';

export default ({
  components: { MainLayout, JJMainLayout },
  data() {
    return {
      isJJ: false,
      currentVersion: null,
    };
  },
  created() {
    this.isJJ = this.pathIncludesJJ();
  },
  mounted() {
    this.fetchCurrentVersion();
    setInterval(this.checkForUpdates, 60000 * 10); // Check every 10 mins
  },
  methods: {
    fetchCurrentVersion() {
      const versionFilePath = `/version.txt?timestamp=${new Date().getTime()}`;
      fetch(versionFilePath)
        .then(response => response.text())
        .then(version => {
          // Only set version if it doesn't contain 'html'
          if (version && version.length > 2 && !version.includes('html')) {
            this.currentVersion = version.trim();
          }
          this.checkForUpdates();
        })
        .catch(error => console.error('Error fetching current version:', error));
    },
    checkForUpdates() {
      const currentVersion = this.currentVersion.trim();
      const versionFilePath = `/version.txt?timestamp=${new Date().getTime()}`;
      fetch(versionFilePath)
        .then(response => response.text())
        .then(version => {
          version = version.trim() ?? ""
          if (version && version.length > 2 && !version.includes('html') && currentVersion.length > 2 && version !== currentVersion) {
            // Wait 10 seconds before reloading
            setTimeout(() => {
              console.log('Current version:', currentVersion, ' New version:', version);
              window.location.reload();
            }, 10000);
          }
        })
        .catch(error => console.error('Error checking for updates:', error));
    },
    pathIncludesJJ() {
      if (window.location && window.location.href) {
        const location = window.location.href.toLowerCase();

        if (location.includes('grayv')) {
          return false;
        }
        return location.includes('jimmyjohns');
      }
    },
  },
  watch: {
    isJJ() {
      // Apply JJ class to body
      document.body.className = '';
      document.body.classList.add('isJJ');
    },
  },
});
</script>
